import { Box, Typography } from '@mui/material'
import type { TClientRequest } from '@modules/types'
import type { TFormattedRequestData } from '@utils/requestFormatter'
import { sectionTitleSx, fieldLabelSx, fieldValueSx, compactFieldSx } from '../styles'

interface LyricsCardInfoProps {
  formattedData: TFormattedRequestData
  clientRequest: TClientRequest
}

const formatBoolValue = (value: string | boolean): string => {
  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No'
  }
  return value
}

const InfoRow = ({ label, value }: { label: string; value: string | boolean }) => (
  <Box sx={compactFieldSx}>
    <Typography sx={fieldLabelSx}>{label}</Typography>
    <Typography sx={fieldValueSx}>{formatBoolValue(value)}</Typography>
  </Box>
)

export const LyricsCardInfo = ({ formattedData, clientRequest }: LyricsCardInfoProps) => {
  const isAcademicJournal = clientRequest.isAcademicJournalOrMagazine === 1

  return (
    <>
      <Box sx={{ mb: 1.5 }}>
        <Typography sx={sectionTitleSx}>Request Details</Typography>
        <Box sx={{ borderRadius: 1, p: 1 }}>
          <InfoRow label="Request Type" value={formattedData.requestTypeName} />
          <InfoRow label="Licensee" value={formattedData.licensee} />
          <InfoRow label="Publisher" value={formattedData.publisher} />
        </Box>
      </Box>

      <Box sx={{ mb: 1.5 }}>
        <Typography sx={sectionTitleSx}>Additional Information</Typography>
        <Box sx={{ borderRadius: 1, p: 1 }}>
          <InfoRow label="Author" value={formattedData.publicationAuthorArrangerEditor} />
          <InfoRow label="Distribution Territory" value={formattedData.distributionTerritory} />
          <InfoRow label="Publication Date" value={formattedData.plannedPublicationDate} />
          <InfoRow label="Reprint" value={formattedData.isReprint} />
          {clientRequest.publicationDescription && (
            <InfoRow label="Publication Description" value={clientRequest.publicationDescription} />
          )}
          <InfoRow label="Academic Journal or Magazine" value={isAcademicJournal ? 'Yes' : 'No'} />
        </Box>
      </Box>
    </>
  )
}
